import React from 'react';

const BudgetFilter = ({ selectedBudget, onBudgetChange, customBudget, onCustomBudgetChange }) => {
  const budgetRanges = [
    { id: 'under-25', label: 'Under $25' },
    { id: '25-50', label: '$25-50' },
    { id: '50-100', label: '$50-100' },
    { id: '100-200', label: '$100-200' },
    { id: '200-500', label: '$200+' },
    { id: 'custom', label: 'Custom' }
  ];

  return (
    <div>
      <h3 className="font-medium text-accent-800 mb-3 flex items-center">
        💰 Budget Range
      </h3>

      <div className="grid grid-cols-2 gap-2 mb-3">
        {budgetRanges.map((budget) => (
          <button
            key={budget.id}
            onClick={() => onBudgetChange(budget.id)}
            className={`p-2 rounded-lg text-sm transition-all duration-200 ${selectedBudget === budget.id
              ? 'border-2 border-green-600 bg-green-200 font-bold text-green-800 shadow-inner transform scale-95'
              : 'border-2 border-accent-200 hover:border-accent-300 bg-white font-medium text-accent-600 hover:bg-accent-50 shadow-sm'
              }`}
          >
            {budget.label}
          </button>
        ))}
      </div>

      {selectedBudget === 'custom' && (
        <div className="flex space-x-2 mt-2">
          <div className="flex-1">
            <input
              type="number"
              placeholder="Min"
              value={customBudget.min}
              onChange={(e) => onCustomBudgetChange('min', e.target.value)}
              className="w-full px-2 py-1 text-sm border border-accent-200 rounded focus:ring-1 focus:ring-green-500 focus:border-green-500"
            />
          </div>
          <div className="flex-1">
            <input
              type="number"
              placeholder="Max"
              value={customBudget.max}
              onChange={(e) => onCustomBudgetChange('max', e.target.value)}
              className="w-full px-2 py-1 text-sm border border-accent-200 rounded focus:ring-1 focus:ring-green-500 focus:border-green-500"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default BudgetFilter;